<div class="filters">

    <div class="filters__name">{{ 'INTERFACE|Filtry' | translate }}</div>

    <div class="filters__filter">
      <div class="filters__filter__name">{{ 'TRANSPORT|Nr zgłoszenia' | translate }}</div>
      <div class="row" >
        <icc-form-field
          size="small"
        >
          <icc-input
              type="text"
              name="documentNumber"
              [value]="documentNumber"
              (valueChange)="documentNumber = $event"
          ></icc-input>
        </icc-form-field>
      </div>
    </div>

    <div class="filters__filter">

      <div class="filters__filter__name">{{ 'TRANSPORT|Status' | translate }}</div>
      <div class="row" >
        <icc-form-field
            size="small"
          >
            <icc-select
                type="text"
                name="status"
                [value]="status"
                (valueChange)="handleStatus($event)"

            >
              <option [value]="null">
                  {{ 'INTERFACE|Wszystkie' | translate }}
              </option>
              <option [value]="el.value" *ngFor="let el of transportStatuses">
                  {{ el.label | translate }}
                </option>
            </icc-select>

          </icc-form-field>

      </div>

    </div>

    <div class="filters__filter" *ngIf="hasContractorFilter">
      <div class="filters__filter__name">{{ 'TRANSPORT|Kontrahent' | translate }}</div>
      <div class="row" >
        <icc-form-field
          size="small"
        >
          <icc-input
              type="text"
              name="contractorCompanyName"
              [value]="contractorCompanyName"
              (valueChange)="contractorCompanyName = $event"
          ></icc-input>
        </icc-form-field>
      </div>
    </div>

    <div class="filters__actions">
        <div class="row">
            <button iccButton appearance="secondary" (click)="emitFilters()">
                {{ 'INTERFACE|Filtruj' | translate }} <icc-icon name="navigate_next"></icc-icon>
            </button>
        </div>

        <div class="row">
            <button iccButton appearance="outline" (click)="resetFilters()">
                {{ 'INTERFACE|Resetuj' | translate }}  <icc-icon name="navigate_before"></icc-icon>
            </button>
        </div>
    </div>

  </div>
